/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_Lowest_PriceInputs */

const he_notifications_type_lowest_price = /** @type {(inputs: Notifications_Type_Lowest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר הנמוך ביותר`)
};

const en_notifications_type_lowest_price = /** @type {(inputs: Notifications_Type_Lowest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest Price Ever`)
};

/**
* | output |
* | --- |
* | "Lowest Price Ever" |
*
* @param {Notifications_Type_Lowest_PriceInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_lowest_price = /** @type {((inputs?: Notifications_Type_Lowest_PriceInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_Lowest_PriceInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_lowest_price(inputs)
	return en_notifications_type_lowest_price(inputs)
});